import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import { getZipCodeValidatorHook } from '@flows/configs/shared/validatorHooks'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  const zipCodeError = schemaUtils.zipCodeErrorMap(issue)
  return zipCodeError ?? { message: ctx.defaultError }
}

const liability_zip = (params: StepConfigParams) =>
  ({
    schema: z.object({
      zip_code: BaseSchema_LiabilityV1GetsafeDe.shape.zip_code,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.zip_code.title',
        },
      },
      {
        type: 'customComponent',
        name: 'ZipCodeInput',
        props: {
          disabledIfValueExists: true,
          shouldTrackValues: true,
        },
        inputs: [],
        outputs: ['zip_code'],
      },
      {
        type: 'infoBox',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.zip_code.subtitle',
        },
      },
    ] as const satisfies AnyStepConfiguration['stepContent'],
    subFlow: params.subFlow,
    nextStep: 'liability_quote',
    onSubmit: getZipCodeValidatorHook(params),
  }) as const satisfies AnyStepConfiguration

export default liability_zip
